export default __webpack_public_path__ + "static/media/img5.736f1c20.JPG";